import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Error = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12 7.75003C12.4142 7.75003 12.75 8.08582 12.75 8.50003V12.5C12.75 12.9142 12.4142 13.25 12 13.25C11.5858 13.25 11.25 12.9142 11.25 12.5V8.50003C11.25 8.08582 11.5858 7.75003 12 7.75003ZM13 15.25C13 15.8023 12.5523 16.25 12 16.25C11.4477 16.25 11 15.8023 11 15.25C11 14.6977 11.4477 14.25 12 14.25C12.5523 14.25 13 14.6977 13 15.25Z'
          fill='currentColor'
        />
        <path
          d='M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <path
        d='M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 14.25C11.4478 14.2501 11 14.6978 11 15.25C11 15.8022 11.4478 16.2499 12 16.25C12.5523 16.25 13 15.8023 13 15.25C13 14.6977 12.5523 14.25 12 14.25ZM12 7.75C11.5858 7.75007 11.25 8.08583 11.25 8.5V12.5C11.25 12.9142 11.5858 13.2499 12 13.25C12.4142 13.25 12.75 12.9142 12.75 12.5V8.5C12.75 8.08579 12.4142 7.75 12 7.75Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
